var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { Component, isValidElement } from 'react';
function isInvalidRenderCellText(text) {
    return text && !isValidElement(text) && Object.prototype.toString.call(text) === '[object Object]';
}
var TableCell = /** @class */ (function (_super) {
    __extends(TableCell, _super);
    function TableCell(props) {
        var _this = _super.call(this, props) || this;
        _this.get = function (obj, dataIndex) {
            if (obj && dataIndex in obj) {
                return obj[dataIndex];
            }
        };
        return _this;
    }
    TableCell.prototype.render = function () {
        var _a = this.props, record = _a.record, column = _a.column, index = _a.index, expandIcon = _a.expandIcon;
        var dataIndex = column.dataIndex, render = column.render, align = column.align, className = column.className, ellipsis = column.ellipsis;
        var text;
        text = this.get(record, dataIndex);
        var tdProps = {};
        var colSpan;
        var rowSpan;
        if (render) {
            text = render(record, text, index);
            // `render` support cell with additional config like `props`
            if (isInvalidRenderCellText(text)) {
                tdProps = text.props || tdProps;
                (colSpan = tdProps.colSpan, rowSpan = tdProps.rowSpan);
                text = text.children;
            }
        }
        if (rowSpan === 0 || colSpan === 0) {
            return null;
        }
        // 对齐方式
        var alignStyle = {};
        if (align) {
            alignStyle.textAlign = align;
        }
        tdProps.style = __assign({}, alignStyle);
        if (column.ellipsis) {
            if (typeof text === 'string') {
                tdProps.title = text;
            }
            else if (text) {
                var textProps = text.props;
                if (textProps && textProps.children && typeof textProps.children === 'string') {
                    tdProps.title = textProps.children;
                }
            }
        }
        var tdClassName = (className || '') + " " + (ellipsis ? 'ellipsis' : '');
        if (tdClassName !== ' ') {
            return (React.createElement("td", __assign({ className: tdClassName }, tdProps),
                expandIcon,
                text));
        }
        else {
            return (React.createElement("td", __assign({}, tdProps),
                expandIcon,
                text));
        }
    };
    return TableCell;
}(Component));
export { TableCell };
